import KratosRecovery from "../src/components/Authentication/Kratos/KratosRecovery";
export default function Recovery() {
  return <KratosRecovery data-sentry-element="KratosRecovery" data-sentry-component="Recovery" data-sentry-source-file="recovery.tsx" />;
}